import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4 m-0 p-0">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up p-0 m-0 w-100">
        <div className="container m0 p-0">
          <div className="row">
            {/* Footer Contact */}
       <div className="col-lg-3">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        We offer a complete range of travel services including local cabs, outstation journeys, airport transfers, corporate travel, and customized packages for every travel need.
      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CF191F" }}></i>
        <a href="tel:+919970007784 " style={{ color: "#fff", textDecoration: "none" }}>+91 9970007784 </a>
      </p>
   <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CF191F" }}></i>
        <a href="tel:+919970353709 " style={{ color: "#fff", textDecoration: "none" }}>+91 9970353709 </a>
      </p>
      {/* Address */}
      <p className="d-fle align-items-start text-dark">
        
        <h6 className="text-dark"><i className="fas fa-map-marker-alt me-2 mt-1 text-dark" style={{ color: "#CF191F" }}></i>Garud Cabs Services</h6>
        Office No.101 Anand Heights
                 Chandan Nagar, Kharadi, Pune,
                 Maharashtra, India-  411014

      </p>



      
    </div>

  
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d92193.03626174961!2d73.78907203674318!3d18.561482861162517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c15fbd7697a5%3A0x8e30fc921edd2023!2sGarudcabs%20%7C%20Best%20Cab%20Service%20in%20Pune!5e1!3m2!1sen!2sin!4v1787111736295!5m2!1sen!2sin" width="100%"
            height="250" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>




    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/garudcabs/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/people/Garudcabs/61556847939567/" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/garudcabs/" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/garudcabs/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul  className="p-0">
            

<li><Link to="/pune-to-mumbai-airport-cab-service"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Airport Cab</Link></li>
<li><Link to="/Pune-to-Outstation-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Outstation Cabs</Link></li>
<li><Link to="/pune-to-mahabaleshwar-cab-service"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Cab</Link></li>
<li><Link to="/pune-to-lonavala-cab-service"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Cab</Link></li>
<li><Link to="/pune-to-matheran-cab-service"><i className="fa fa-car darkcolor"></i> Pune to Matheran Cabs</Link></li>
<li><Link to="/pune-to-5-jyotirlinga-cab-service"><i className="fa fa-car darkcolor"></i> Pune to 5 Jyotirlinga Darshan Cab</Link></li>
<li><Link to="/pune-to-bhimashankar-cab-service"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Cab</Link></li>
<li><Link to="/Pune-to-Aurangabad-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Aurangabad Cab Service</Link></li>
<li><Link to="/Pune-to-Nashik-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Nashik Cab Service</Link></li>
<li><Link to="/Pune-to-Kolhapur-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Kolhapur Cab Service</Link></li>
<li><Link to="/Pune-to-Alibaug-Cab"><i className="fa fa-car darkcolor"></i> Pune to Alibaug Cab</Link></li>
<li><Link to="/Pune-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Goa Cab Service</Link></li>
<li><Link to="/Goa-to-Pune-Cabs"><i className="fa fa-car darkcolor"></i> Goa to Pune Cabs</Link></li>
<li><Link to="/Innova-Crysta-Cab-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta Cab in Pune</Link></li>
<li><Link to="/Ertiga-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Pune</Link></li>
<li><Link to="/pune-to-ashtavinayak-cab-service"><i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak Cabs</Link></li>
<li><Link to="/Pune-to-Goa-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Goa Cabs</Link></li>
<li><Link to="/Pune-to-Jyotirlinga-Darshan-Package" ><i className="fa fa-car darkcolor"></i> Pune to Jyotirlinga Darshan Package</Link></li>
<li><Link to="/Pune-to-Akkalkot-Cabs" className=""><i className="fa fa-car darkcolor"></i> Pune to Akkalkot Cabs</Link></li>
<li><Link to="/Pune-to-Pandharpur-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Pandharpur Cab</Link></li>
<li><Link to="/Pune-to-Grishneshwar-Jyotirlinga-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Grishneshwar Jyotirlinga Cab</Link></li>
<li><Link to="/pune-to-mumbai-cab-service" className=""><i className="fa fa-car darkcolor"></i> Pune to Mumbai Cabs</Link></li>
<li><Link to="/Innova-Crysta-On-Rent-in-Pune" className=""><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Pune</Link></li>
<li><Link to="/Ertiga-Hire-in-Pune" className=""><i className="fa fa-car darkcolor"></i> Ertiga Hire in Pune</Link></li>
<li><Link to="/Pune-to-Shrivardhan-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Shrivardhan Cab</Link></li>
<li><Link to="/Pune-to-Jyotiba-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Jyotiba Cab</Link></li>
<li><Link to="/Pune-to-Shirdi-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cab</Link></li>
<li><Link to="/Sedan-Cab-Service" className=""><i className="fa fa-car darkcolor"></i> Sedan Cab Service</Link></li>
<li><Link to="/Hyundai-Xcent-Cabs-in-Pune" className=""><i className="fa fa-car darkcolor"></i> Hyundai Xcent Cabs in Pune</Link></li>
<li><Link to="/Swift-Dzire-On-Rent-in-Pune" className=""><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent in Pune</Link></li>
<li><Link to="/Aura-Cab-Service-in-Pune" className=""><i className="fa fa-car darkcolor"></i> Aura Cab Service in Pune</Link></li>
<li><Link to="/Pune-Darshan-Sedan-Cab-Booking" className=""><i className="fa fa-car darkcolor"></i> Pune Darshan Sedan Cab Booking</Link></li>
<li><Link to="/Pune-to-Ayodhya-Tour-Package" className=""><i className="fa fa-car darkcolor"></i> Pune to Ayodhya Tour Package</Link></li>
<li><Link to="/Pune-to-Mahabaleshwar-Sedan-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Sedan Cab</Link></li>

                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul className="p-0">
<li><Link to="/Pune-Airport-Cab-Sedan-Service"><i className="fa fa-car darkcolor"></i> Pune Airport Cab Sedan Service</Link></li>

<li><Link to="/Pune-to-Shirdi-Sedan-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Sedan Cabs</Link></li>
<li><Link to="/Sedan-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Sedan Cab Booking Pune</Link></li>
<li><Link to="/Pune-Hyundai-Aura-Cab"><i className="fa fa-car darkcolor"></i> Pune Hyundai Aura Cab</Link></li>
<li><Link to="/Pune-to-Lonavala-Sedan-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Sedan Cabs</Link></li>
<li><Link to="/Online-Sedan-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Sedan Cab Booking Pune</Link></li>
<li><Link to="/Pune-to-Vidarbha-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Vidarbha Cab Service</Link></li>
<li><Link to="/Pune-to-Hyderabad-Cab"><i className="fa fa-car darkcolor"></i> Pune to Hyderabad Cab</Link></li>
<li><Link to="/Pune-to-Ujjain-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ujjain Cab</Link></li>
<li><Link to="/Corporate-Cab-Service-Pune"><i className="fa fa-car darkcolor"></i> Corporate Cab Service Pune</Link></li>
<li><Link to="/Pune-Railway-Station-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Railway Station Cab Service</Link></li>
<li><Link to="/Cheap-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Cheap Cab Service in Pune</Link></li>
<li><Link to="/Online-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking Pune</Link></li>
<li><Link to="/Pune-to-Bangalore-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bangalore Cab</Link></li>
<li><Link to="/Pune-to-Gujarat-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Gujarat Cab Service</Link></li>
<li><Link to="/Pune-to-Nagpur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Nagpur Cab</Link></li>
<li><Link to="/Pune-to-Ahmednagar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ahmednagar Cab</Link></li>
<li><Link to="/Pune-to-Latur-Cab" ><i className="fa fa-car darkcolor"></i> Pune to Latur Cab</Link></li>
<li><Link to="/pune-to-mumbai-darshan-cab-service" className=""><i className="fa fa-car darkcolor"></i> Pune to Mumbai Darshan Cab</Link></li>
<li><Link to="/Pune-to-Satara-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Satara Cab</Link></li>
<li><Link to="/Pune-to-Sangli-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Sangli Cab</Link></li>
<li><Link to="/pune-to-solapur-cab-service" className=""><i className="fa fa-car darkcolor"></i> Pune to Solapur Cab</Link></li>
<li><Link to="/Pune-Airport-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune Airport Cab</Link></li>
<li><Link to="/Pune-to-Rajasthan-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Rajasthan Cab</Link></li>
<li><Link to="/Pune-to-Sambhajinagar-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Sambhajinagar Cab</Link></li>
<li><Link to="/Pune-to-Dhule-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Dhule Cab</Link></li>
<li><Link to="/Pune-to-Jalna-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Jalna Cab</Link></li>
<li><Link to="/Pune-to-Telangana-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Telangana Cab</Link></li>
<li><Link to="/Pune-to-Indore-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune to Indore Cab</Link></li>
                 
                 <li><Link to="/Pune-Taxi-Service" className=""><i className="fa fa-car darkcolor"></i> Pune Taxi Service</Link></li>
<li><Link to="/Best-Cab-Service-in-Pune" className=""><i className="fa fa-car darkcolor"></i> Best Cab Service in Pune</Link></li>
<li><Link to="/Pune-One-Way-Cab-Service" className=""><i className="fa fa-car darkcolor"></i> Pune One Way Cab Service</Link></li>
<li><Link to="/Pune-Local-and-Outstation-Cab" className=""><i className="fa fa-car darkcolor"></i> Pune Local and Outstation Cab</Link></li>
<li><Link to="/Pune-to-Jalgaon-Cab-Service" className=""><i className="fa fa-car darkcolor"></i> Pune to Jalgaon Cab Service</Link></li>

                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul className="p-0">
<li><Link to="/Pune-to-Thane-Cab"><i className="fa fa-car darkcolor"></i> Pune to Thane Cab</Link></li>
<li><Link to="/Pune-to-Panvel-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Panvel Cabs</Link></li>
<li><Link to="/Pune-to-Nanded-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Nanded Cab Service</Link></li>
<li><Link to="/Pune-to-Surat-Cab"><i className="fa fa-car darkcolor"></i> Pune to Surat Cab</Link></li>
<li><Link to="/Pune-to-Ahmedabad-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ahmedabad Cab</Link></li>
<li><Link to="/Pune-to-Mahabaleshwar-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Taxi</Link></li>
<li><Link to="/Pune-to-Igatpuri-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Igatpuri Taxi</Link></li>
<li><Link to="/Pune-to-Tamhini-Ghat-Cab"><i className="fa fa-car darkcolor"></i> Pune to Tamhini Ghat Cab</Link></li>
<li><Link to="/Pune-to-Trimbakeshwar-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Trimbakeshwar Cab Service</Link></li>
<li><Link to="/Pune-to-Ashtavinayak-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak Darshan Cab</Link></li>
<li><Link to="/Pune-to-Jejuri-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Jejuri Cab Service</Link></li>
<li><Link to="/Pune-to-Aundha-Nagnath-Cab"><i className="fa fa-car darkcolor"></i> Pune to Aundha Nagnath Cab</Link></li>
<li><Link to="/Pune-to-Konkan-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Cab</Link></li>
<li><Link to="/mumbai-airport-to-pune-cab-service"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune Cab</Link></li>
<li><Link to="/Mumbai-Airport-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai Airport Cab Service</Link></li>
<li><Link to="/Navi-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport Cab</Link></li>
<li><Link to="/Cab-Service-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Service in Navi Mumbai</Link></li>
<li><Link to="/Innova-Crysta-On-Rent-in-Mumbai" ><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Mumbai</Link></li>
<li><Link to="/Ertiga-On-Rent-in-Mumbai" className=""><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Mumbai</Link></li>
<li><Link to="/Mumbai-to-Mahabaleshwar-Cab" className=""><i className="fa fa-car darkcolor"></i> Mumbai to Mahabaleshwar Cab</Link></li>
<li><Link to="/Cab-Service-in-Thane" className=""><i className="fa fa-car darkcolor"></i> Cab Service in Thane</Link></li>
<li><Link to="/Mumbai-to-Goa-Cab" className=""><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cab</Link></li>
<li><Link to="/Cab-Service-in-Pimpri-Chinchwad" className=""><i className="fa fa-car darkcolor"></i> Cab Service in Pimpri Chinchwad</Link></li>
<li><Link to="/Pune-Innova-Cabs" className=""><i className="fa fa-car darkcolor"></i> Pune Innova Cabs</Link></li>
<li><Link to="/Best-Outstation-Cab-Service-in-Pune" className=""><i className="fa fa-car darkcolor"></i> Best Outstation Cab Service in Pune</Link></li>
<li><Link to="/Pune-to-Panchgani-Cabs" className=""><i className="fa fa-car darkcolor"></i> Pune to Panchgani Cabs</Link></li>
<li><Link to="/Hinjewadi-Cab-Service" className=""><i className="fa fa-car darkcolor"></i> Hinjewadi Cab Service</Link></li>
<li><Link to="/Navi-Mumbai-International-Airport-Cabs" className=""><i className="fa fa-car darkcolor"></i> Navi Mumbai International Airport Cabs</Link></li>
<li><Link to="/Cab-Service-in-Kharadi" className=""><i className="fa fa-car darkcolor"></i> Cab Service in Kharadi</Link></li>
<li><Link to="/Cab-Service-in-Wagholi" className=""><i className="fa fa-car darkcolor"></i> Cab Service in Wagholi</Link></li>
<li><Link to="/Cab-Service-in-Mundhwa" className=""><i className="fa fa-car darkcolor"></i> Cab Service in Mundhwa</Link></li>
<li><Link to="/Cab-Service-in-Kalyani-Nagar" className=""><i className="fa fa-car darkcolor"></i> Cab Service in Kalyani Nagar</Link></li>
<li><Link to="/Cab-Service-in-Kothrud" className=""><i className="fa fa-car darkcolor"></i> Cab Service in Kothrud</Link></li>                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Garud Cabs Services</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              {/* <div className="col-lg-4">
                <div className="payment-list">
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-01.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-02.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-03.svg" alt="img" />
                  </a>
                </div>
              </div> */}
              {/* <div className="col-lg-4">
                <ul className="privacy-link">
                  <li><a href="privacy-policy.html">Privacy</a></li>
                  <li><a href="terms-condition.html">Terms & Condition</a></li>
                  <li><a href="javascript:void(0);">Refund Policy</a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


